import { jwtDecode } from 'jwt-decode'

export function isTokenExpired(token) {
  if (token) {
    try {
      const decoded = jwtDecode(token)
      const currentTime = Math.floor(Date.now() / 1000)
      return decoded.exp < currentTime
    } catch (error) {
      console.error('Invalid token:', error)
      return true
    }
  }
  return true
}

export function getRolesFromToken(token) {
  if (token) {
    try {
      const decoded = jwtDecode(token)
      return decoded.roles || []
    } catch (error) {
      console.error('Invalid token:', error)
      return []
    }
  }
  return []
}

export function jwtAllDecoder(token) {
  if (token) {
    try {
      const decoded = jwtDecode(token)
      return decoded || []
    } catch (error) {
      console.error('Invalid token:', error)
      return []
    }
  }
  return []
}
